<template>
  <pt-export-history class="pt-export-history__withData" :type="type"></pt-export-history>
</template>

<script>
import PtExportHistory from './index'
export default {
  name: 'pt-export-history__withData',
  components: {
    'pt-export-history': PtExportHistory
  },
  props: {
    type: {
      type: String,
      default: ''
    }
  }
}
</script>
